import { Slot } from '@radix-ui/react-slot';
import { cn } from '@shadcn/lib/utils';
import React from 'react';

const Link = ({ asChild, className, ...props }: { readonly asChild?: boolean } & React.ComponentProps<'a'>) => {
  const Comp = asChild ? Slot : 'a';

  return <Comp {...props} className={cn('cursor-pointer', className)} />;
};

export { Link };
